import {
  Box,
  Button,
  Container,
  Grid,
  Pagination,
  Stack,
  Typography,
} from "@mui/material";

import { useEffect } from "react";
import { useState } from "react";
import AutofocusTextFields from "./autoFocusTextField";
import { encrypt } from "../../utils/encryption";
import Swal from "sweetalert2";
import { updatePin } from "./resetPinApi";
import { getUpdateData } from "./resetPinCustomApiHander";
import { swalAlertPopProps } from "../../utils/commonUtils";
import { ENCRYPTIONKEY } from "../../utils/api";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import ElegantLogo from "../../assets/elegantPrimeLogo.png";
import { ArrowBackIcon } from "../../common/icon";
import { useNavigate } from "react-router";

const ResetMpin = () => {
  const [itemData, setItemData] = useState({ passcode: "" });
  const [itemData2, setItemData2] = useState({ passcode: "" });
  const navigate = useNavigate();

  function generateRandomString(length) {
    const chars = "0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      result += chars[randomIndex];
    }
    return result;
  }
  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box
        px={{ sm: 5, xs: 2 }}
        py={5}
        container
        sx={{
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
          minHeight: "100vh",
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            background:
              "linear-gradient(90deg, #EBEAFF 0%, #C3C3F8 36.54%, #7E7EEB 59.13%, #01008B 100%)",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            borderRadius: "14px",
          }}
        >
          <Grid
            container
            sx={{
              py: "50px",
              px: { xs: "20px", sm: "10px" },
            }}
          >
            <Grid item px={3}>
              <ArrowBackIcon
                sx={{ cursor: "pointer" }}
                onClick={() => navigate("/home")}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid
                container
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Grid item xs={6}>
                  <img
                    src={ElegantLogo}
                    alt="Elegant Logo"
                    style={{ width: "100%" }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Box
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "20px 30px",
                }}
              >
                <Grid container spacing={2} pt={3}>
                  <Grid item xs={12} sx={{ textAlign: "center" }}>
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 600,
                        textTransform: "uppercase",
                        color: "primary.main",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      Reset Mpin
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sx={{ paddingTop: "30px !important" }}>
                    <Typography
                      variant="h6"
                      sx={{
                        color: "primary.main",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      Enter MPIN
                    </Typography>
                    <AutofocusTextFields
                      itemData={itemData}
                      setItemData={setItemData}
                    />
                  </Grid>
                  <Grid item xs={12} sx={{ paddingBottom: "20px !important" }}>
                    <Typography
                      variant="h6"
                      sx={{
                        color: "primary.main",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      Confirm MPIN
                    </Typography>
                    <AutofocusTextFields
                      itemData={itemData2}
                      setItemData={setItemData2}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      sx={{
                        mb: 5,
                        fontWeight: 600,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        width: "100%",
                      }}
                      onClick={() => {
                        console.log("mpin reset ", itemData2.passcode);
                        const randomString = generateRandomString(4);
                        let encoded = encrypt(
                          itemData2.passcode + randomString,
                          ENCRYPTIONKEY,
                        );
                        if (
                          itemData2.passcode !== itemData.passcode ||
                          itemData2.passcode.length != 4 ||
                          itemData.passcode.length != 4
                        ) {
                          Swal.fire({
                            text: "Please Enter Same value",
                            icon: "warning",

                            ...swalAlertPopProps,
                          });
                        } else {
                          getUpdateData(
                            {
                              mPin: encoded,
                              isBiometricAuthentication: false,
                            },
                            updatePin,
                            Swal,
                          );
                        }

                        console.log("call ", {
                          mPin: encoded,
                          isBiometricAuthentication: true,
                        });
                      }}
                      variant="contained"
                    >
                      Update
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ResetMpin;
